import ProjectQaIssues from './ProjectQaIssues';
import { qaIssueFilterMap, qaIssueNameMap } from './constants/qaIssues';

export { qaIssueFilterMap, qaIssueNameMap };

export default ProjectQaIssues;
